// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jx-2";
export var container = "_jx-4";
export var dismissButton = "_jx-3";
export var hasPaddingBottom = "_jx-6";
export var last = "_jx-e";
export var scrollbarThumb = "_jx-c";
export var scrollbarTrack = "_jx-b";
export var selected = "_jx-9";
export var spin = "_jx-1";
export var spinning = "_jx-0";
export var suggestionItem = "_jx-d";
export var suggestionsPanel = "_jx-5";
export var tonePill = "_jx-8";
export var tonesContainer = "_jx-7";
export var unselected = "_jx-a";